import Vue from 'vue';
import Router from 'vue-router';
import ConsumerAccountDetails from '@/views/ConsumerAccountDetails.vue';
import JobExecutions from '@/views/JobExecutions.vue';
import Reports from '@/views/Reports.vue';
import LegacyRedirect from '@/views/LegacyRedirect.vue';
import IncomingRedirect from '@/views/IncomingRedirect.vue';
import FileLoadHistory from '@/views/FileLoadHistory.vue';
import AuditMessages from '@/views/AuditMessages.vue';
import ImportSummary from '@/views/ImportSummary.vue';
import QualificationsAndRewardsSummary from '@/views/QualificationsAndRewardsSummary.vue';
import QualificationOverride from '@/views/QualificationOverride.vue';
import RewardsValidation from '@/views/RewardsValidation.vue';
import RecompSummary from '@/views/RecompSummary.vue';
import store from '../store';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/:fiId/incomingredirect/:destination/:destinationarg?',
      name: 'incomingredirect',
      component: IncomingRedirect,
      props: true,
    },
    {
      path: '/legacyredirect/:destination',
      name: 'legacyredirect',
      component: LegacyRedirect,
      props: true,
    },
    {
      path: '/:clientId/consumeraccountdetails',
      name: 'consumeraccountsearch',
      component: ConsumerAccountDetails,
    },
    {
      path: '/:clientId/consumeraccountdetails/:customerId',
      name: 'consumeraccountdetails',
      component: ConsumerAccountDetails,
    },
    {
      path: '/:clientId',
      name: 'root',
    },
    {
      path: '/:clientId/jobexecutions',
      name: 'jobexecutions',
      component: JobExecutions,
      meta: {
        kasasaOnly: true,
      },
    },
    {
      path: '/:clientId/reports',
      name: 'reports',
      component: Reports,
    },
    {
      path: '/:clientId/fileloadhistory',
      name: 'fileloadhistory',
      component: FileLoadHistory,
    },
    {
      path: '/:clientId/auditmessages',
      name: 'auditmessages',
      component: AuditMessages,
      meta: {
        kasasaOnly: true,
      },
    },
    {
      path: '/:clientId/importsummary',
      name: 'importsummary',
      component: ImportSummary,
    },
    {
      path: '/:clientId/qualificationsrewardssummary',
      name: 'qualificationsrewardssummary',
      component: QualificationsAndRewardsSummary,
    },
    {
      path: '/:clientId/qualificationoverride',
      name: 'qualificationoverride',
      component: QualificationOverride,
    },
    {
      path: '/:clientId/rewardsvalidation',
      name: 'rewardsvalidation',
      component: RewardsValidation,
      meta: {
        kasasaOnly: true,
      },
    },
    {
      path: '/:clientId/recompsummary/:reloadId?',
      name: 'recompsummary',
      component: RecompSummary,
      props: true,
      meta: {
        kasasaOnly: true,
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'root') {
    if (!(store.state as any).auth || !((store.state as any).auth as any).sessionData) {
      next(false);
    } else if ((store.state as any).isFiUser) {
      next(`/${((store.state as any).auth as any).sessionData.fiId}/reports`);
    } else {
      next(`/${to.params.clientId}/jobexecutions`);
    }
  } else if (to.matched.some(record => record.meta.kasasaOnly)) {
    // May not have loaded the session yet, so must do so before we can check if this is an fi user
    if ((!(store.state as any).auth || !((store.state as any).auth as any).sessionData)) {
      await store.dispatch('auth/initializePortalSession');
    }

    if (!(store.state as any).auth || !((store.state as any).auth as any).sessionData
      || ((store.state as any).isFiUser)) {
      // FI user or just not logged in, so bounce.
      next({ name: 'root' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
